import { Options, merge } from 'highcharts';
import { baseChartOptions } from './base-chart.options';

/**
 * Configuration for Line chart type
 * Extends the base chart configuration
 */
export const lineChartOptions: Options = merge({}, baseChartOptions, {
    chart: {
        type: 'line'
    },
    plotOptions: {
        line: {
            lineWidth: 2,
            states: {
                hover: {
                    lineWidth: 3
                }
            },
            marker: {
                enabled: true
            }
        }
    },
    tooltip: {
        headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
        pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
    }
} as Options);